import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Field, PasswordInput } from "../public/Auth";

export const ChangePasswordForm = () => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="card-rx space-y-5 p-7" data-testid="change-password-form">
      <h2 className="text-lg font-semibold text-white">Change password</h2>
      <Field label="Current password"><PasswordInput required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} testId="current-password-input" /></Field>
      <Field label="New password"><PasswordInput required minLength={8} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} testId="new-password-input" /></Field>
      <Field label="Confirm new password"><PasswordInput required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} testId="confirm-password-input" /></Field>
      <button disabled={busy} className="btn-primary" data-testid="change-password-submit-btn">{busy ? "Saving…" : "Update password"}</button>
    </form>
  );
};

const ProfileForm = () => {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ full_name: user.full_name, email: user.email || "" });
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/auth/profile", f); setUser(data.user); toast.success("Profile saved"); } catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <form onSubmit={submit} className="card-rx space-y-5 p-7" data-testid="profile-form">
      <h2 className="text-lg font-semibold text-white">Profile</h2>
      <Field label="Phone number"><input disabled value={user.phone} className="input-rx opacity-60" data-testid="profile-phone" /></Field>
      <Field label="Full name"><input required minLength={2} value={f.full_name} onChange={(e) => setF({ ...f, full_name: e.target.value })} className="input-rx" data-testid="profile-name-input" /></Field>
      <Field label="Email (optional, used for receipts)"><input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="input-rx" data-testid="profile-email-input" /></Field>
      <p className="text-xs text-slate-500">Member since {fmtDate(user.created_at)}</p>
      <button className="btn-primary" data-testid="profile-save-btn">Save profile</button>
    </form>
  );
};

export default function Account() {
  return (
    <div className="space-y-10">
      <div><p className="eyebrow">Account</p><h1 className="mt-2 text-3xl font-bold text-white sm:text-4xl">Account settings</h1></div>
      <div className="grid gap-6 lg:grid-cols-2"><ProfileForm /><ChangePasswordForm /></div>
    </div>
  );
}
